import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';

const { FiCalendar, FiVideo, FiCheckCircle } = FiIcons;
const { FaWhatsapp } = FaIcons;

const ThankYouPage = () => {
  return (
    <div className="min-h-screen bg-[#020617] text-slate-200 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        <motion.div 
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          className="bg-white/5 border border-white/10 rounded-3xl p-8 md:p-12 text-center backdrop-blur-xl relative overflow-hidden"
        >
          {/* Confetti Effect bg */}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-20">
             <div className="absolute top-10 left-10 w-2 h-2 bg-amber-500 rounded-full animate-ping" />
             <div className="absolute top-20 right-20 w-3 h-3 bg-emerald-500 rounded-full animate-ping" style={{ animationDelay: '0.5s' }} />
             <div className="absolute bottom-10 left-1/2 w-2 h-2 bg-red-500 rounded-full animate-ping" style={{ animationDelay: '1s' }} />
          </div>

          <SafeIcon icon={FiCheckCircle} className="text-6xl text-emerald-400 mx-auto mb-6" />
          
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">You’re In! <br/> Your Diamond 2.0 Seat is Reserved 🎉</h1>
          
          <p className="text-slate-300 mb-8 max-w-lg mx-auto">
            Congratulations on taking the first step towards your ₹1 Crore journey. Check your email for confirmation.
          </p>

          <div className="space-y-4 mb-8">
            <div className="p-4 rounded-xl bg-blue-500/10 border border-blue-500/20 flex items-center gap-4">
              <div className="w-10 h-10 rounded-full bg-blue-500/20 flex items-center justify-center flex-shrink-0">
                <SafeIcon icon={FiVideo} className="text-blue-400 text-xl" />
              </div>
              <div className="text-left">
                <p className="font-bold text-white">Join Zoom Session</p>
                <p className="text-sm text-slate-400">Link has been sent to your email</p>
              </div>
            </div>

            <div className="p-4 rounded-xl bg-purple-500/10 border border-purple-500/20 flex items-center gap-4">
              <div className="w-10 h-10 rounded-full bg-purple-500/20 flex items-center justify-center flex-shrink-0">
                <SafeIcon icon={FiCalendar} className="text-purple-400 text-xl" />
              </div>
              <div className="text-left">
                <p className="font-bold text-white">Add to Calendar</p>
                <p className="text-sm text-slate-400">Don't miss the start time!</p>
              </div>
            </div>

            <div className="p-4 rounded-xl bg-green-500/10 border border-green-500/20 flex items-center gap-4 cursor-pointer hover:bg-green-500/20 transition-colors">
              <div className="w-10 h-10 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0">
                <SafeIcon icon={FaWhatsapp} className="text-green-400 text-xl" />
              </div>
              <div className="text-left">
                <p className="font-bold text-white">Join WhatsApp VIP Group</p>
                <p className="text-sm text-slate-400">Get reminders & updates</p>
              </div>
            </div>
          </div>

          <div className="aspect-video bg-black/40 rounded-xl flex items-center justify-center border border-white/5 relative group cursor-pointer overflow-hidden">
             {/* Placeholder for Video */}
             <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent flex flex-col justify-end p-6">
                <p className="text-white font-bold text-lg">Message from Abdul Hakkim</p>
                <p className="text-slate-400 text-sm">Watch before the session starts</p>
             </div>
             <div className="w-16 h-16 rounded-full bg-white/10 backdrop-blur-md flex items-center justify-center border border-white/20 group-hover:scale-110 transition-transform">
                <div className="w-0 h-0 border-t-[10px] border-t-transparent border-l-[18px] border-l-white border-b-[10px] border-b-transparent ml-1"></div>
             </div>
          </div>

        </motion.div>
      </div>
    </div>
  );
};

export default ThankYouPage;